body = $('body');
body.on('change', '.TAT_zone_type', function () {
    getTATPrice();
});

body.on('change', '.TAT_price_free', function () {
    let priceMethodWrapperEl = $('#price_method_wrapper');

    priceMethodWrapperEl.addClass('d-none');
    if (parseInt($(this).val()) !== 0) {
        priceMethodWrapperEl.removeClass('d-none');
    } else {
        $('.TAT_price_method[value="0"]').prop("checked", true);
    }

    getTATPrice();
});

body.on('change', '.TAT_price_method', function () {
    getTATPrice();
});

function getTATPrice() {
    let url = $('#price').attr('data-url');
    let zoneType = $('.TAT_zone_type:checked').val();
    let priceFree = $('.TAT_price_free:checked').val();
    let priceMethod = $('.TAT_price_method:checked').val();
    let partner = $('#partner').val();

    $.ajax({
        url: url,
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {
            zone_type: zoneType,
            price_free: priceFree,
            price_method: priceMethod,
            partner: partner
        },
        success: function (data) {
            $.each(data.priceTablesTAT, function (i, priceTableTAT) {
                $('.TAT_price_free[value="' + priceTableTAT.free_sessions + '"]').parent().parent().find('.TAT_price_description').html(priceTableTAT.description);
            });
            if (data.status === true || data.status === 'true') {
                $('#price').val(data.price);
            }
        },
        error: function (err) {
            $('.ajaxFormError').remove();
            if (err.status == 422) { // when status code is 422, it's a validation issue

                $('#success_message').fadeIn().html(err.responseJSON.message);
                // display errors on each form field
                $.each(err.responseJSON.errors, function (i, error) {
                    var el = $(document).find('[name="' + i + '"]');
                    //el.after($('<div class="ajaxFormError mt-1 w-100 toast mb-2 d-flex align-items-center text-white bg-danger border-0" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body"><div class="d-flex align-items-center"><i class="fas fa-danger mr-1"></i>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</div></div></div>'));
                    el.after($('<div class="ajaxFormError alert alert-danger mt-2"><span class="svg-icon svg-icon-danger svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="black"/><rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="black"/><rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="black"/></svg></span><div class="d-flex flex-column"><h4 class="mb-1 text-dark">Alerta</h4><span>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</span></div></div>'));
                    //el.after($('<span class="alert-error">'+error[0].replace(i.replace('_', ' '), el.attr('data-title'))+'</span>'));
                });
            }
        },
        complete: function () {
            $('button[data-kt-indicator="on"]').removeAttr('data-kt-indicator');
        }
    });
}
